import React from "react";
import FormComponent from "../components/formComponent";
import AlertComponent from "../components/alertComponent";
import {renderReport} from "../components/elementList";
import {dashboardSettings} from '../helper/dashboardSettings';

let documentation = {
    title: 'Add Acuadori Dashboard',
    brief: 'Adds a dashboard to Thingsboard Acuadori for a customer',
    content: `Creates an Acuadori dashboard and assign the dashboard to each customer type of the input customer.
     Each customer account type can view its assigned devices and field report through the new created dashboard.`
}

class UiDashboard extends React.Component {

    static defaultProps = {
        settings: {
            baseName: 'Dashboard',
            namePostpend: '-db',
            widget: () => null,
        },
        customers: null,
        services: {},
        finished: (data) => {
        }
    };

    constructor(props) {
        super(props);

        this.dashboardService = props.services;

        this.state = {
            dashboard: null,
        };
    }

    renderNewDashboard() {

        return (
            <div>
                <FormComponent
                    initialValues={{name: this.props.customers.name}}
                    validateFunc={this.handleValidate}
                    submitFunc={this.handleSubmitNewDashboard}
                    inputs={[
                        {
                            key: 'name', type: 'text', inputType: 'input', placeholder: 'Name', label: 'Name', fixedPre:"Acuadori"
                        }
                    ]}
                />
            </div>
        );
    }

    handleValidate = (values) => {
        const errors = {};
        if (!values.name) {
            errors.name = 'Required';
        }
        return errors;
    };

    handleSubmitNewDashboard = (values) => {
        let name = 'Acuadori ' + values.name;
        let dashboard = dashboardSettings(name);
        return this.dashboardService.addDashboard(JSON.stringify(dashboard))
            .then(this.handleSubmitNewDashboardNext)
            .catch(this.handleSubmitError);
    };

    handleSubmitNewDashboardNext = (response) => {
        this.setState({dashboard: response});
        this.handleAssignDashboardToCustomers(response);
    };

    handleAssignDashboardToCustomers = (dashboard) => {
        let {customers} = this.props;
        let customerIds = customers.instances.map((instance) => {
            return instance.id;
        });

        this.assignDashboardToCustomers(dashboard.id.id, customerIds);
    };

    assignDashboardToCustomers = (dashboardId, customerIds) => {
        return this.dashboardService.assignDashboardToCustomer(dashboardId, customerIds)
            .then(this.handleAssignDashboardToCustomersNext)
            .catch(this.handleSubmitError);
    };

    handleAssignDashboardToCustomersNext = (response) => {
        this.props.finished({dashboard: response});
    };

    handleSubmitError = (error) => {
        let message = 'Error: ' + error.message;
        this.renderAlert(message, 'warning');
    };

    renderAlert = (message, variant) => {
        this.setState({messageAlert: message, variantAlert: variant, showAlert: true});
    };

    reportDashboard = () => {
        let {dashboard} = this.state;
        if (!dashboard) {
            return null;
        }

        return {
            'DASHBOARD ID ': dashboard.id.id,
            'DASHBOARD NAME ': dashboard.title
        };
    };

    render() {
        let {dashboard} = this.state;
        let {showAlert, variantAlert, messageAlert} = this.state;
        return (
            <div className="container mb-5">
                <AlertComponent show={showAlert} variant={variantAlert} message={messageAlert} dismissFunc={() => {
                    this.setState({showAlert: false})
                }}/>

                {renderReport(this.reportDashboard())}

                {!dashboard && this.renderNewDashboard()}
            </div>
        );
    }
}

export default UiDashboard;
export {
    UiDashboard, 
    documentation
}
